module.exports = __webpack_public_path__ + "static/media/veneto-3-08.9f1fd5b7.jpg";